const loader = props => {
    return (
        <div className="sfly-share-spinner">
            <div className="sfly-share-icon-spinner"/>
        </div>
    );
}


export default loader;